import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {
    transform(input: string): string {
        if (!input || !input.length) { return input; }
        return input[0].toUpperCase() + input.substr(1);
    }
}
